import {Utils} from 'hasta-la-vista-ui-core'
import {OrderService} from 'hasta-la-vista-middleware-api/service'

export default {
    name: 'booking',

    props: {
        bookings: false,
        bookingHistory: Array,
        showView: {type: Boolean, default: true},
        showDownload: {type: Boolean, default: true},
        isSingleBooking: {type: Boolean, default: false},

    },

    methods: {
        showSuccessfulPage(bookin_id, booking_number){
            this.$router.push("/booking-successful/" + bookin_id + '/' + booking_number)
        },
        downloadPDF(bookingNumber, bookingId, booking = {}) {
            booking.loadingPdf = true;
            window.open(OrderService.generateConfirmationPDF(bookingNumber, bookingId))
            booking.loadingPdf = false
        },
    },

    created() {
        // console.log("Booking History",this.bookingHistory)
    },

    computed: {
        classes() {
            return {}
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/profile/booking/booking.js